<template>
  <div id="not-found-page">
    <b-container>
      <b-row>
        <b-col id="title"> ERROR 404 </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="text-center">
          <b-img src="@/assets/images/not-found.png" fluid alt="Not Found" />
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col id="message">Oops! Page not found.</b-col>
      </b-row>
      <b-row class="mt-4 mb-5">
        <b-col class="text-center">
          <b-button :to="{ name: 'Home' }" variant="outline-primary">
            Back Home
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style lang="scss" scoped>
#not-found-page {
  min-height: 100vh;
  padding-top: 40px;
  padding-bottom: 60px;

  #title {
    color: #ff830e;
    font-family: 'SKModernistBold', sans-serif;
    font-size: 30px;
    text-align: center;
  }

  #message {
    color: #ff830e;
    font-size: 18px;
    text-align: center;
  }
}
</style>
